var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 5.468v13.064a.1.1 0 0 0 .019.066c.015.025.05.062.11.096.126.069.286.078.429.005l12.802-6.532a.3.3 0 0 0 .12-.099.13.13 0 0 0 0-.136.3.3 0 0 0-.12-.099L6.558 5.301a.46.46 0 0 0-.429.005.3.3 0 0 0-.11.096.1.1 0 0 0-.019.066m-1.5 0v13.064c0 1.305 1.508 2.132 2.74 1.503l12.802-6.532c1.277-.652 1.277-2.354 0-3.006L7.24 3.965c-1.232-.629-2.74.198-2.74 1.503",
    clipRule: "evenodd"
  })));
};
export default SvgPlay;